import { ReturnLight } from '@repo/go-icons';
import { Button, Illustration } from '@repo/go-ui';
import clsx from 'clsx';
import { useTranslation } from 'react-i18next';

type NegativePlaceholderProps = {
  message: string;
  redirectToBasicParameters?: () => void;
  className?: string;
};

export function NegativePlaceholder({ message, redirectToBasicParameters, className }: NegativePlaceholderProps) {
  const { t } = useTranslation();
  return (
    <div className={clsx('go-widgets-placeholder-block', className)} style={{ display: 'flex', alignItems: 'center' }}>
      <div style={{ width: '35%', aspectRatio: 1 / 1 }}>
        <Illustration.EmptyWidget style={{ width: '100%', height: '100%' }} />
      </div>

      <div className="go-widgets-placeholder-content">
        <span>{t(message)}</span>
        {redirectToBasicParameters && (
          <Button onClick={redirectToBasicParameters} icon={<ReturnLight />} style={{ width: 'fit-content' }} size="m">
            {t('Redirect-to-basic-parameters')}
          </Button>
        )}
      </div>
    </div>
  );
}
